import React from 'react';

interface Props {
    className?: string;
}

const TinyLoader = ({
                       className
                    }: Props) => {

    return (
        <div className={`${className ?? className} w-8 h-8'} flex justify-center items-center`}>
            <div className="loader ease-linear rounded-full self-center border-8 border-t-8 border-DARKEST_GREY h-10 w-10"/>
        </div>
    );
};

export default TinyLoader;